export enum ESimCardStatus {
    CANCELED = "CANCELED",
    DONE = "DONE",
    ERROR = "ERROR",
    VALIDATED = "VALIDATED",
    ONGOING = "ONGOING",
    IN_VALIDATION = "IN_VALIDATION",
}

export interface ICharge {
    billingType: string;
    catalogChargeCode: string;
    catalogPricePlanCode: string;
    defaultPriceVatIncluded: number;
    description: string;
}

export interface ISimCardRequest {
    status?: ESimCardStatus;
}
